// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"0d116519","952":"a87c2dbb"}[chunkId] + ".chunk.js";
};